import { render, staticRenderFns } from "./discounts-offer.vue?vue&type=template&id=712ac604&scoped=true&"
import script from "./discounts-offer.vue?vue&type=script&lang=js&"
export * from "./discounts-offer.vue?vue&type=script&lang=js&"
import style0 from "./discounts-offer.vue?vue&type=style&index=0&id=712ac604&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ac604",
  null
  
)

export default component.exports